<template>
  <bs-modal class="text-center"
    name="final-session"
    :ok-title="$t('javascript.yes_proceed')"
    :cancel-title="$t('javascript.cancel')"
    medium-modal
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"

    :value="value"
    @input="$emit('input', $event)"
  >
    <h1 class="text-center">
      <i class="fa fa-question-circle-o"></i>
    </h1>
    <p>
      {{ $t('javascript.are_you_sure_declare_final') }}
    </p>
  </bs-modal>
</template>

<script>
  import BsModal from './bs_modal'

  export default {
    name: "final-session-modal",
    props: ['value'],
    components: {BsModal},
  }
</script>
